const MARK = 'v1';

export { MARK };
